import React, { useEffect, useState } from "react";
import { currentUser, DOCTOR_BOOKING_FLAG, getCurrentUserRole, ROLES_NAME } from "modules/utilities/utility";
import ProductDetails from "./ProductDetails";
import CreateTicketScreen from "../../CreateTicket/CreateTicketV2";
import { useCustomer } from "modules/dashboards/actionables/store";
import _ from "lodash";
import AppsMenu from "modules/navbar/top/AppsMenu";
import ProfileDropdown from "modules/navbar/top/ProfileDropdown";

const APPS_ROLES = [
  ROLES_NAME.SUPER_ADMIN,
  ROLES_NAME.ADMIN,
  ROLES_NAME.MAKER,
  ROLES_NAME.CHECKER,
  ROLES_NAME.PUBLISHER,
  ROLES_NAME.DOCTOR,
  ROLES_NAME.CLINIC_DOCTOR,
  ROLES_NAME.CONSULT_DOCTOR,
];

const TopNavRightSideNavItem = () => {
  const { customerData, ticketData } = useCustomer();
  const [isLeadDetailsPage, setIsLeadDetailsPage] = useState(false);

  useEffect(() => {
    const pathArray = window.location.pathname.split("/");
    setIsLeadDetailsPage(_.get(pathArray, 1) === "lead-details");
  }, [window.location.pathname]);

  const showApps = APPS_ROLES.includes(getCurrentUserRole());
  const hideCreateTicket =
    ["doctor", "consult_doctor"].includes(currentUser) && !DOCTOR_BOOKING_FLAG;

  return (
    <div className="topbar__right">
      {showApps && <AppsMenu />}

      <ProductDetails />

      {!hideCreateTicket && (
        <CreateTicketScreen
          customerData={isLeadDetailsPage ? customerData : null}
          ticketData={ticketData}
        />
      )}

      <div className="topbar__divider" />

      <ProfileDropdown />
    </div>
  );
};

export default TopNavRightSideNavItem;
